import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  children: ReactNode
  className?: HTMLAttributes<HTMLHeadingElement>['className']
}

export function H3({ children, className }: Props) {
  return (
    <h3
      data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_H3}
      className={cn('text-lg font-semibold text-moss-950', className)}
    >
      {children}
    </h3>
  )
}
